import { createFileRoute } from "@tanstack/react-router";
import { useLingui } from "@lingui/react/macro";
import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useMenuItem } from "@/hooks/menu-items";
import { useCatalogScope } from "@/hooks/useCatalogScope";
import { Skeleton } from "@/components/ui/skeleton";
import { BackToMenuItemsLink, MenuItemDetailView, MenuItemFormDialog } from "@/components/menus";

export const Route = createFileRoute("/(protected)/_layout/menus/$menuItemId")({
  component: MenuItemDetailPage,
});

function MenuItemDetailPage() {
  const { t } = useLingui();
  const { menuItemId } = Route.useParams();
  const id = Number(menuItemId);
  const { isAuthenticated, hasPermission } = useAuth();
  const scope = useCatalogScope();
  const { data: item, isLoading, error } = useMenuItem(id, isAuthenticated);
  const [editOpen, setEditOpen] = useState(false);

  if (isLoading) {
    return (
      <div className="flex flex-1 flex-col gap-5 p-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-48 w-full" />
      </div>
    );
  }

  if (error || !item) {
    return (
      <div className="flex flex-1 flex-col gap-6 p-6">
        <BackToMenuItemsLink />
        <p className="text-(--color-text-secondary)">{t`This menu item couldn't be found.`}</p>
      </div>
    );
  }

  const canEdit = hasPermission("menu:write");

  return (
    <div className="flex flex-1 flex-col gap-5 py-5">
      <MenuItemDetailView item={item} canEdit={canEdit} onEdit={() => setEditOpen(true)} />
      <MenuItemFormDialog
        open={editOpen}
        onOpenChange={setEditOpen}
        editingId={item.id}
        companyId={scope.dialogFixedCompanyId}
        defaultCompanyId={scope.dialogDefaultCompanyId}
        organizationId={scope.effectiveOrganizationId}
        canSelectOrganization={scope.isInternalRecipeViewer && !scope.fixedOrganizationId}
      />
    </div>
  );
}
